import '@tiger/skeleton/dist/skeleton.css';

export { default } from '@tiger/skeleton';
